export default "__VITE_ASSET__Duc9YsVP__"